import React, { useContext } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';

import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useCostCenterService from '../../../app/services/hooks/useCostCenterService';

interface Props {
    costCenterId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const CostCenterSwitchChange = ({ costCenterId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeCostCenter, fetchingActiveCostCenter } = useCostCenterService();

    const active = (value: boolean) => {
        setChecked(value);

        activeCostCenter(costCenterId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={costCenterId} callback={active} />;
};

export default CostCenterSwitchChange;
